import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '@usimweb/core/services';

import { Env } from '@usimweb/core/models';
import { DialogService, RequestSupportDialogComponent } from '@usimweb/ui/dialogs';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {
  private projectId = '';
  private project = {};

  public mainColor = '';

  constructor(@Inject('environment') environment: Env, private route: ActivatedRoute, private router: Router, private dialogService: DialogService, private apiService: ApiService) {
    this.mainColor = environment.mainColor;
  }

  ngOnInit(): void {
    this.projectId = this.route.snapshot.params['id'];

    console.log('oninit');
    console.log('Project ID:', this.projectId);

    this.apiService.getProjectById(this.projectId).subscribe((project) => {
      console.log('Project:', project);
      this.project = project;
    });
  }

  requestSupportDialog() {
    this.dialogService.openContentDialog(RequestSupportDialogComponent, { uuid: this.projectId, projects: this.project }, 'Request support').subscribe();
  }

  openCADRequirementsDialog() {}
}
